define('fukit/view/block/vertically.spaced.components.container.view',['require','exports','module','underscore','uikit/uikit'],function(require, exports, module) {
  //prettier-ignore
  var _     = require('underscore'),
      UIKit = require('uikit/uikit');

  var VerticallySpacedComponentsContainerView = UIKit.ComponentsContainerView.extend({
    className: 'vertically spaced components container',
    options: {
      spacing: null,
    },
    initialize: function() {
      UIKit.ComponentsContainerView.prototype.initialize.apply(this, arguments);
      this.on(
        'childview:change:visible add:child remove:child first:render',
        _.debounce(this.updateLastVisibleChild),
        this
      );
    },

    updateAttributes: function() {
      this.addClass(this.getOption('spacing'), this.getBoolOption('spacing'));
    },

    updateLastVisibleChild: function() {
      var children = this.children.toArray();
      _.each(children, function(child) {
        child.$el.removeClass('last-child');
      });
      var lastVisible = _.find(children.reverse(), function(child) {
        return child.visible;
      });
      if (lastVisible) {
        lastVisible.$el.addClass('last-child');
      }
    },
  });

  module.exports = VerticallySpacedComponentsContainerView;
});

